import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AngularDraggableModule } from "angular2-draggable";
import { InlineSVGModule } from "ng-inline-svg-2";
import { ToastrModule } from "ngx-toastr";
import { RouterModule } from "@angular/router";
import { AgGridModule } from "ag-grid-angular";
import { ExternalMAMRoutes } from "./externam-mam.routes";
import { IExternalMAMRepository } from "../../domain/external-mam/i-external-mam.repository";
import { ExternalMamRepositoryImpl } from "../../infrastructure/external-mam/external-mam-repository.service";
import { ExternalMAMPanelComponent } from "./external-mam-panel/external-mam-panel.component";
import { ExternalMAMProvidersCardComponent } from "./external-mam-providers-layout/external-mam-providers-card.component";
import { ExternalMAMProvidersLayoutComponent } from "./external-mam-providers-layout/external-mam-providers-layout.component";
import { ExternalMAMProvidersSetupLayoutComponent } from "./external-mam-providers-setup/external-mam-providers-setup-layout.component";
import { ExternalMAMProvidersSetupStepTwoComponent } from "./external-mam-providers-setup/external-mam-providers-setup-step-two/external-mam-providers-setup-step-two.component";
import { ExternalMAMProvidersSetupStepOneComponent } from "./external-mam-providers-setup/external-mam-providers-setup-step-one/external-mam-providers-setup-step-one.component";
import { ExternalMAMGatewaysCardComponent } from "./external-mam-providers-layout/external-mam-gateways-card.component";
import { ExternalMAMGatewayPlaygroundComponent } from "./external-mam-gateway-playground/external-mam-gateway-playground.component";
import { ExternalMAMSearchResultsNameCell } from "./external-mam-gateway-playground/search-grid-components/external-mam-search-results-name-cell/external-mam-search-results-name-cell.component";
import { ExternalMAMSearchResultsStatusCell } from "./external-mam-gateway-playground/search-grid-components/external-mam-search-results-status-cell/external-mam-search-results-status-cell.component";
import { ExternalMAMSearchResultsActionsCell } from "./external-mam-gateway-playground/search-grid-components/external-mam-search-results-actions-cell/external-mam-search-results-actions-cell.component";
import { ExternalMAMCustomizeTableComponent } from "./external-mam-gateway-playground/external-mam-customize-table/external-mam-customize-table.component";
import { MatRadioModule } from "@angular/material/radio";
import { ContextMenuModule } from "@perfectmemory/ngx-contextmenu";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    AngularDraggableModule,
    ContextMenuModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 5000,
    }),
    RouterModule.forRoot(ExternalMAMRoutes, { onSameUrlNavigation: "reload" }),
    AgGridModule,
    MatRadioModule,
  ],
  providers: [
    {
      provide: IExternalMAMRepository,
      useClass: ExternalMamRepositoryImpl,
    },
  ],
  declarations: [
    ExternalMAMPanelComponent,
    ExternalMAMProvidersLayoutComponent,
    ExternalMAMProvidersCardComponent,
    ExternalMAMGatewaysCardComponent,
    ExternalMAMProvidersSetupLayoutComponent,
    ExternalMAMProvidersSetupStepOneComponent,
    ExternalMAMProvidersSetupStepTwoComponent,
    ExternalMAMGatewayPlaygroundComponent,
    ExternalMAMSearchResultsNameCell,
    ExternalMAMSearchResultsStatusCell,
    ExternalMAMSearchResultsActionsCell,
    ExternalMAMCustomizeTableComponent,
  ],
  exports: [RouterModule],
})
export class ExternalMAMModule {}
